import React from 'react'
import MessageIcon from "images/message-green.png";
import ProfileIcon from "images/profile-green.png";
import ArrowIcon from "images/arrow-right-green.png";

const Input = ({ icon, placeholder, name, defaultValue, type, ...rest }) => {
  return (
    <div className='realtive w-full mb-4 flex flex-col'>
      {icon && icon}
      <input
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        name={name}
        className="w-full border border-solid border-gray-300 py-4 pl-11 pr-3 bg-transparent outline-none rounded-md text-gray-700"
        { ...rest }
      />
      <img
        src={name == 'fName' ? ProfileIcon : name == 'email' ? MessageIcon : ArrowIcon}
        className="!absolute left-6 translate-y-3/4 w-6 h-6"
      />
    </div>
  )
}

export default Input